<template>
    <p
        v-if="html"
        :class="
            twMerge(
                'whitespace-pre-line text-left text-[0.75rem] font-bold uppercase leading-[1.3] tracking-[-0.01em] lg:text-[0.875rem] lg:leading-[1.5]',
                locale === 'en' && 'text-[0.875rem] lg:leading-[1.3]',
                locale === 'ja' && '',
                locale === 'ko' && '',
                $attrs.class,
            )
        "
        v-html="htmlPurify(html)"
    ></p>
    <p
        v-else
        :class="
            twMerge(
                'whitespace-pre-line text-left text-[0.75rem] font-bold uppercase leading-[1.3] tracking-[-0.01em] lg:text-[0.875rem] lg:leading-[1.5]',
                locale === 'en' && 'text-[0.875rem] lg:leading-[1.3]',
                locale === 'ja' && '',
                locale === 'ko' && '',
                $attrs.class,
            )
        "
    >
        <slot />
    </p>
</template>

<script setup>
import { htmlPurify } from "~/lib/utils";
import { twMerge } from "tailwind-merge";
const { locale } = useI18n();
const props = defineProps(["html"]);
</script>
